import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiServer, FiLayers, FiMapPin, FiShield, FiCode, FiLink, FiVideo, FiGlobe, FiGithub, FiCloud, FiActivity } from 'react-icons/fi';
import { HUB_EXPLORER_LINKS, getLocaleFromPathname } from '../config/localeRoutes';
import './HubExplorer.css';

const HUB_ICONS = {
  webrtc: FiServer,
  platform: FiLayers,
  hosting: FiMapPin,
  rgpd: FiShield,
  api: FiCode,
  integration: FiLink,
  zoomAlt: FiVideo,
  sfu: FiServer,
  stunTurn: FiGlobe,
  sovereign: FiShield,
  openSource: FiGithub,
  cloud: FiCloud,
  latency: FiActivity,
};

function HubExplorer() {
  const { t } = useTranslation();
  const location = useLocation();
  const locale = getLocaleFromPathname(location.pathname);
  const links = HUB_EXPLORER_LINKS[locale] || HUB_EXPLORER_LINKS.fr;

  return (
    <section className="hub-explorer" id="infrastructure">
      <div className="hub-explorer-container">
        <div className="hub-explorer-header">
          <h2 className="hub-explorer-title">{t('hubExplorer.title')}</h2>
          <p className="section-quick-answer">{t('hubExplorer.quickAnswer')}</p>
          <p className="hub-explorer-subtitle">{t('hubExplorer.subtitle')}</p>
        </div>

        <div className="hub-explorer-grid">
          {links.map((link) => {
            const Icon = HUB_ICONS[link.iconKey];
            return (
              <Link key={link.to} to={link.to} className="hub-explorer-card">
                <div className="hub-explorer-icon">{Icon && <Icon aria-hidden />}</div>
                <h3 className="hub-explorer-card-title">{t(`hubExplorer.${link.labelKey}`)}</h3>
                <p className="hub-explorer-card-description">{t(`hubExplorer.${link.descKey}`)}</p>
                <div className="hub-explorer-arrow">→</div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default HubExplorer;
